import { useCallback } from 'react'
import { useInfiniteQuery } from 'react-query'
import useCurrentUser from '../use-current-user'
import messagesFetchService from '../../services/api/messages-fetch'
import { get, flatten } from 'lodash'
import useMessagesCache from '../use-messages-cache'

const useMessagesInfinite = ({
    pageSize = 5,
    searchString,
    box = 'in',
}) => {
    const { keys: cacheKeys } = useMessagesCache()
    const { currentUser } = useCurrentUser()
    const recipientId = box === 'in' ? get(currentUser, 'id') : undefined
    const authorId = box === 'out' ? get(currentUser, 'id') : undefined
    const cacheKey = box === 'in' ? cacheKeys.INBOX_INFINITE : cacheKeys.OUTBOX_INFINITE

    const fetchMessages = useCallback(async (key, offset = 0) => {
        return messagesFetchService({ offset, limit: pageSize, authorId, recipientId, searchString })
    }, [pageSize, authorId, recipientId, searchString])

    const {
        data,
        isFetching,
        isFetchingMore,
        fetchMore,
        canFetchMore,
    } = useInfiniteQuery(cacheKey, fetchMessages, {
        getFetchMore: (lastPage, allPages) => lastPage.offset + lastPage.limit >= lastPage.total ? false : lastPage.offset + lastPage.limit,
        enabled: Boolean(currentUser)
    })

    return {
        isFetching,
        isFetchingMore,
        fetchMore,
        canFetchMore,
        messages: data ? flatten(data.map(d => d.items)) : [],
    }
}

export default useMessagesInfinite
